import React from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle, formatDate, styleMerge } from '../../utils/utils';
import CBLabelAndCheckbox from '../shared/CBLabelAndCheckbox';
import VehicleListTd from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTd';

class ManufacturerServiceBookEntryListItem extends React.Component {
  navigateToMaintenance = () => {
    const { history, entry, onOpenEntry } = this.props;
    const vehicleId = entry.vehicle.id;
    const maintenanceId = entry.maintenance_id;
    if (maintenanceId) {
      history.push(`/workshop-vehicle/${vehicleId}/maintenances/${maintenanceId}`);
    } else {
      if (entry.document_url) {
        window.open(entry.document_url, '_blank');
      } else if (entry.url) {
        window.open(entry.url, '_blank');
      } else {
        onOpenEntry(entry);
      }
    }
  };

  getStatusColor = (status) => {
    switch (status) {
      case 'available':
        return '#4CAF50';  // Green
      case 'not_available':
        return '#F44336';  // Red
      case 'canceled':
        return '#F44336';  // Red
      case 'in_progress':
        return '#FFC107';  // Yellow
      case 'finished':
        return '#2196F3';  // Blue
      case 'expired':
        return '#FF5722';  // Deep Orange
      default:
        return '#FFFFFF';  // White
    }
  };

  checkBoxChanged = () => {
    const {
      selected,
      select,
      unselect,
      entry,
    } = this.props;

    if (selected) {
      unselect(entry.id);
    } else {
      select(entry.id);
    }
  };

  onShowClicked = (e) => {
    const {
      entry,
      onOpenEntry
    } = this.props;
    e.stopPropagation();

    if (entry.document_url) {
      window.open(entry.document_url, '_blank');
    } else if (entry.url) {
      window.open(entry.url, '_blank');
    } else {
      onOpenEntry(entry);
    }
  };

  onCancelClicked = (e) => {
    const { entry, onCancelEntry } = this.props;
    e.stopPropagation();
    onCancelEntry(entry.id);
  };

  onRecoverClicked = (e) => {
    const { entry, onRecoverEntry } = this.props;
    e.stopPropagation();
    onRecoverEntry(entry.id);
  };

  isExpired = () => {
    const { entry } = this.props;
    if (!entry.expires_at) return false;
    const today = new Date();
    const expiresAt = new Date(entry.expires_at);
    return expiresAt < today;
  };

  render() {
    const { entry, t, selectedFields, selected } = this.props;
    const vehicle = entry.vehicle;

    return (
      <CBMediaQuery>
        {screenSize => (
          <tr style={getStyle(screenSize, styles, 'row')}>
            {
              false && (
                <td style={getStyle(screenSize, styles, 'tableRegNumTd')}>
                  <CBLabelAndCheckbox
                    additionalStyles={{ justifyContent: 'center' }}
                    checked={selected}
                    onChange={this.checkBoxChanged}
                  />
                </td>
              )
            }

            {selectedFields.includes('vehicle') && (
              <VehicleListTd
                onClick={this.navigateToMaintenance}
                textPrimary={vehicle.registration_number}
                textSecondary={[vehicle.manufacturer, vehicle.model_name].filter(Boolean).join(' ')}
                additionalStylesPrimaryText={{ fontSize: 24 }}
              />
            )}

            {selectedFields.includes('maintenance') && (
              <VehicleListTd
                onClick={this.navigateToMaintenance}
                textPrimary={entry.maintenance_work_number || 'Ei huoltoa Ovio:ssa'}
                textSecondary={formatDate(entry.maintenance_pickup_date)}
              />
            )}

            {selectedFields.includes('status') && (
              <VehicleListTd
                onClick={this.navigateToMaintenance}
                textPrimary={
                  <div style={{
                    ...getStyle(screenSize, styles, 'statusBadge'),
                    backgroundColor: this.getStatusColor(entry.status)
                  }}>
                    {entry.status_display} {entry.form_data && entry.status === 'available' && `(${t('formStarted', { ns: 'ManufacturerServiceBook' })})`}
                  </div>
                }
              />
            )}

            {selectedFields.includes('external_status') && (
              <VehicleListTd
                onClick={this.navigateToMaintenance}
                textPrimary={entry.external_status_display ? entry.external_status_display : '-'}
                textSecondary={entry.external_status_reason_display ? entry.external_status_reason_display : null}
              />
            )}

            {selectedFields.includes('expires_at') && (
              <VehicleListTd
                onClick={this.navigateToMaintenance}
                textPrimary={formatDate(entry.expires_at)}
              />
            )}

            {selectedFields.includes('actions') && (
              <td style={styleMerge(getStyle(screenSize, styles, 'tableValueTd'), getStyle(screenSize, styles, 'alignCenter'))}>
                {entry.is_canceled && !this.isExpired() ? (
                  <div
                    onClick={this.onRecoverClicked}
                    className='opacity-on-hover'
                    style={styleMerge(getStyle(screenSize, styles, 'actionButton'), getStyle(screenSize, styles, 'recoverButton'))}
                  >
                    <img
                      src='/img/icon_checkmark.svg'
                      alt={t('recoverEntry', { ns: 'ManufacturerServiceBook' })}
                      title={t('recoverEntry', { ns: 'ManufacturerServiceBook' })}
                      style={getStyle(screenSize, styles, 'actionIcon')}
                    />
                  </div>
                ) : !entry.is_canceled && (entry.status !== 'finished' && entry.status !== 'expired') ? (
                  <div
                    onClick={this.onCancelClicked}
                    className='opacity-on-hover'
                    style={styleMerge(getStyle(screenSize, styles, 'actionButton'), getStyle(screenSize, styles, 'cancelButton'))}
                  >
                    <img
                      src='/img/icon_close_white.svg'
                      alt={t('cancelEntry', { ns: 'ManufacturerServiceBook' })}
                      title={t('cancelEntry', { ns: 'ManufacturerServiceBook' })}
                      style={getStyle(screenSize, styles, 'actionIcon')}
                    />
                  </div>
                ) : null}
              </td>
            )}

            <td onClick={this.onShowClicked} style={styleMerge(getStyle(screenSize, styles, 'tableValueTd'), getStyle(screenSize, styles, 'alignCenter'))}>
              {
                (entry.status == 'available' || entry.status == 'in_progress' || entry.document_url) && (
                      <img
                        className='opacity-on-hover'
                        src='/img/icon_dsb.png'
                        alt='Hae raportti'
                        style={getStyle(screenSize, styles, 'infoIcon')}
                      />
                    )
              }
            </td>

          </tr>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    row: {
      height: '60px',
      width: '100%',
      marginBottom: 2,
      cursor: 'pointer',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
      }
    },
    tableRegNumTd: {
      fontFamily: 'TitilliumWeb-Bold',
      fontSize: 18,
      color: '#FFFFFF',
      left: 0,
      padding: '8px 16px 8px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    statusBadge: {
      display: 'inline-block',
      padding: '4px 8px',
      borderRadius: 4,
      fontSize: 14,
      fontWeight: 'bold'
    },
    infoIcon: {
      height: 32,
      width: 32,
    },
    actionButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    cancelButton: {
    },
    recoverButton: {
    },
    actionIcon: {
      height: 18,
      width: 18,
      filter: 'brightness(0) invert(1)',
    },
    alignCenter: {
      textAlign: 'center',
    },
    tableValueTd: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
      padding: 8,
      cursor: 'pointer',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
  },
  medium: {},
  small: {}
};

export default translate('ManufacturerServiceBookEntryListItem')(withRouter(ManufacturerServiceBookEntryListItem));